import React, {useEffect, useRef} from "react";
import {useAppSelector} from "../../app/hooks";
import {ChatMessage, messagesSelector, MessageType} from "../chatbotSlice";
import {UserMessage} from "./UserMessage";
import {Thinking} from "./Thinking";
import {ChatConvoStarters} from "./Convostarter/ChatConvoStarters";
import {BotTextMessage} from "./Message/BotTextMessage";
import {BotVideoMessage} from "./Message/BotVideoMessage";
import {BotGalleryMessage} from "./Message/BotGalleryMessage";
import {BotStripeMessage} from "./Message/BotStripeMessage";

export const WidgetMessages: React.FC = () => {
    const messages = useAppSelector(messagesSelector);
    const scrollRef = useRef<HTMLDivElement>(null);
    const lastMessageRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        const lastMessage = lastMessageRef.current;

        if (!scrollContainer || !lastMessage) return;

        // Wait for layout to settle
        const handleScroll = () => {
            const containerHeight = scrollContainer.clientHeight;
            const messageHeight = lastMessage.offsetHeight;

            if (messageHeight <= containerHeight) {
                scrollContainer.scrollTo({
                    top: scrollContainer.scrollHeight,
                    behavior: "smooth"
                })
            } else {
                lastMessage.scrollIntoView({behavior: "smooth", block: "start"});
            }
        };

        requestAnimationFrame(() => {
            setTimeout(handleScroll, 0);
        });

    }, [messages]);

    return <div
        id="chatbot_panel"
        ref={scrollRef}
        className="h-full overflow-y-auto flex flex-col justify-between px-4"
    >
        <div className="flex w-full flex-col sm:mt-0">
            {messages.map((message: ChatMessage, index: number) => {
                const isLastMessage = index === messages.length - 1;

                const messageElement = (() => {
                    if (message.isBot) {
                        switch (message.message.messageType) {
                            case MessageType.TEXT:
                                return <React.Fragment key={`bot-text-wrap-${index}`}>
                                        <BotTextMessage key={`bot-text-${index}`} index={index} message={message}/>
                                        {(messages.length <= 1) && <ChatConvoStarters key={index}/>}
                                    </React.Fragment>
                            case MessageType.VIDEO:
                                return <BotVideoMessage key={`bot-video-${index}`} index={index}
                                                        message={message}/>
                            case MessageType.GALLERY:
                                return <BotGalleryMessage key={`bot-gallery-${index}`} index={index}
                                                          message={message}/>
                            case MessageType.STRIPE:
                                return <BotStripeMessage key={`bot-stripe-${index}`} index={index}
                                                         message={message}/>
                            case MessageType.TOOL:
                                break
                            default:
                                console.error("Unhandled message type:", message.message.messageType);
                                return <BotTextMessage key={`bot-fallback-${index}`} index={index}
                                                       message={message}/>;
                        }
                    } else {
                        return <UserMessage
                            key={`user-${index}`}
                            index={index}
                            message={message}
                            messages={messages}
                        />
                    }
                })()

                return <div key={`wrap-${index}`} ref={isLastMessage ? lastMessageRef : null}>
                    {messageElement}
                </div>
            })}
            <Thinking/>
        </div>
    </div>
}
